import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionItemDirective, AccordionItemsDirective } from './items.directive';
import { AccordionComponent } from './accordion.component';
/**
 * NgModule definition for the Accordion component.
 */
export class AccordionModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        AccordionComponent,
        AccordionItemDirective,
        AccordionItemsDirective
    ],
    exports: [
        AccordionComponent,
        AccordionItemDirective,
        AccordionItemsDirective
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AccordionModule_tsickle_Closure_declarations() {
/** @type {?} */
AccordionModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AccordionModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
